import * as actionTypes from "../actionTypes";
import initialState from "../../../../../../reducers/initialState";

export default function advanceSplitReducer(state = initialState.currentOffer.advanceSplitData, action) {
  const initialAdvanceSplitData = initialState.currentOffer.advanceSplitData;
  switch (action.type) {
    case actionTypes.LOAD_OFFER_ADVANCE_SPLIT_SUCCESS: {
      return {
        ...state,
        advanceSplit: action.payload.advanceSplit,
        isAdvanceSplitLoaded: true,
        saving: false,
        isDirty: false
      };
    }

    case actionTypes.LOAD_OFFER_ADVANCE_SPLIT_FAILED: {
      return initialAdvanceSplitData;
    }

    case actionTypes.SAVE_OFFER_ADVANCE_SPLIT_STARTED: {
      return {
        ...state,
        saving: true
      };
    }
    case actionTypes.SAVE_OFFER_ADVANCE_SPLIT_FAILED: {
      return {
        ...state,
        saving: false
      };
    }

    case actionTypes.SAVE_OFFER_ADVANCE_SPLIT_SUCCESS: {
      return {
        ...state,
        isAdvanceSplitLoaded: true,
        saving: false,
        isDirty: false
      };
    }

    default:
      return state;
  }
}
